/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Jméno`
};

const da_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Fornavn`
};

const de_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Vorname`
};

const en_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Firstname`
};

const es_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Nombre`
};

const fr_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Prénom`
};

const hu_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Keresztnév`
};

const it_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Nome`
};

const nl_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Voornaam`
};

const pl_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Imię`
};

const pt_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Nome`
};

const sv_firstname = /** @type {(inputs: {}) => string} */ () => {
	return `Förnamn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const firstname = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.firstname(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("firstname", locale)
	if (locale === "cs") return cs_firstname(inputs)
	if (locale === "da") return da_firstname(inputs)
	if (locale === "de") return de_firstname(inputs)
	if (locale === "en") return en_firstname(inputs)
	if (locale === "es") return es_firstname(inputs)
	if (locale === "fr") return fr_firstname(inputs)
	if (locale === "hu") return hu_firstname(inputs)
	if (locale === "it") return it_firstname(inputs)
	if (locale === "nl") return nl_firstname(inputs)
	if (locale === "pl") return pl_firstname(inputs)
	if (locale === "pt") return pt_firstname(inputs)
	return sv_firstname(inputs)
};